export function toolbarMenu(): ng.IDirective {
    return {
        restrict: "E",
        template: require('./toolbarMenu.html')
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarMenu.directive.ts
 **/